import { DOCUMENT } from '@angular/common';
import { Component, OnInit, ViewChild, forwardRef, Input, ElementRef, Inject, AfterViewInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';


@Component({
  selector: 'pgs-custom-select',
  templateUrl: './custom-select.component.html',
  styleUrls: ['./custom-select.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => CustomSelectComponent),
    multi: true
  }]
})
export class CustomSelectComponent implements OnInit, AfterViewInit {

  @Input() public options: any[];
  @ViewChild('selector', { static: true }) public selector: ElementRef;

  public currentValue: string;
  public isDisabled: boolean;

  private onChange: (_: any) => any;
  private onTouched: () => any;

  constructor(@Inject(DOCUMENT) private readonly document: Document) {
    this.onChange = (_: any) => { };
    this.onTouched = () => { };

    this.options = [];
  }

  ngOnInit(): void {
    this.document.addEventListener('click', e => this.closeAllSelect(e));
  }

  ngAfterViewInit(): void {
    this.init(this.selector.nativeElement);
  }

  private async init(divBase: HTMLElement): Promise<void> {

    let divSelected: any, select: HTMLSelectElement,
        divSelect: any,
        divOption: any;

    select = divBase.getElementsByTagName('select')[0];

    divSelected = this.document.createElement('DIV');
    divSelected.setAttribute('class', 'select-selected');
    divSelected.innerHTML = select.options[select.selectedIndex].innerHTML;

    divBase.appendChild(divSelected);

    divSelect = this.document.createElement('DIV');
    divSelect.setAttribute('class', 'select-items select-hide');

    for (let j = 0; j < select.length; j++) {
      divOption = this.document.createElement('DIV');
      divOption.innerHTML = select.options[j].innerHTML;
      divOption.addEventListener('click', function() {

          let sas: HTMLAllCollection,
              select: HTMLSelectElement,
              previous: HTMLDivElement;

          select = this.parentNode.parentNode.getElementsByTagName('select')[0];
          previous = this.parentNode.previousSibling;

          for (let i = 0; i < select.length; i++) {
            if (select.options[i].innerHTML === this.innerHTML) {
              select.selectedIndex = i;
              previous.innerHTML = this.innerHTML;
              sas = this.parentNode.getElementsByClassName('same-as-selected');

              for (let l = 0; l < sas.length; l++) {
                sas[l].removeAttribute('class');
              }

              this.setAttribute('class', 'same-as-selected');
              break;
            }
          }

          previous.click();
      });

      divSelect.appendChild(divOption);
    }

    divBase.appendChild(divSelect);

    const closeAllSelectScope = this.closeAllSelect.bind(this);

    divSelected.addEventListener('click', function(e: Event) {
      e.stopPropagation();
      closeAllSelectScope(this);

      this.nextSibling.classList.toggle('select-hide');
      this.classList.toggle('select-arrow-active');
    });
  }

  public writeValue(value: string): void {
    if (value) { this.currentValue = value; }
  }

  public registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  public setDisabledState(state: boolean): void {
    this.isDisabled = state ;
  }

  public closeAllSelect(element: any): void {

    const items: HTMLCollectionOf<Element> = this.document.getElementsByClassName('select-items'),
          selected: HTMLCollectionOf<Element> = this.document.getElementsByClassName('select-selected'),
          list: number[] = [];

    for (let i = 0; i < selected.length; i++) {
      element === selected[i]
        ? (list.push(i), this.onChange(this.currentValue = element.innerText))
        : selected[i].classList.remove('select-arrow-active');
    }

    for (let i = 0; i < items.length; i++) {
      if (list.indexOf(i)) { items[i].classList.add('select-hide'); }
    }
  }
}

